export type MenuTitleProps = { children: React.ReactNode };

export function MenuTitle(props: MenuTitleProps) {
  const { children } = props;

  return (
    <div className="flex items-center gap-2 p-4 text-slate-100">{children}</div>
  );
}
